import * as actionTypes from "../actionTypes";

export const appLoadingAutoLoginComplete = () => {
    return {
        type: actionTypes.APP_LOADING_AUTO_LOGIN_COMPLETE
    }
};